var map = {
	"./b026/footer/footer": 590,
	"./b027site/footer/footer": 591,
	"./b027sport/footer/footer": 592,
	"./bet365luck/footer/footer": 593,
	"./betl/footer/footer": 594,
	"./common/footer/footer": 595,
	"./dafa/footer/footer": 596,
	"./taiyangcheng018/footer/footer": 597
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650;


//////////////////
// WEBPACK FOOTER
// ./src/components/different ^\.\/.*\/footer\/footer$
// module id = 650
// module chunks = 27